// Built-in slide templates for the Konva editor.
// All coordinates are designed for 1080x1080 canvas.
// IDs are placeholders; applyTemplate() generates unique IDs at apply time.

export const EDITOR_TEMPLATES = [
  {
    id: 'blank',
    name: 'Blank',
    category: 'Basic',
    preview: { bg: '#FFFFFF', accent: '#E5E7EB' },
    elements: [],
  },
  {
    id: 'title-slide',
    name: 'Title Slide',
    category: 'Basic',
    preview: { bg: '#1E40AF', accent: '#BFDBFE' },
    elements: [
      { type: 'rect', x: 0, y: 0, width: 1080, height: 1080, fill: '#1E40AF' },
      { type: 'text', x: 80, y: 400, text: 'Your Title Here', fontSize: 80, fontFamily: 'Arial', fill: '#FFFFFF', fontStyle: 'bold', width: 920, align: 'center' },
      { type: 'text', x: 80, y: 520, text: 'Add your subtitle here', fontSize: 40, fontFamily: 'Arial', fill: '#BFDBFE', width: 920, align: 'center' },
    ],
  },
  {
    id: 'quote',
    name: 'Quote',
    category: 'Content',
    preview: { bg: '#F9FAFB', accent: '#3B82F6' },
    elements: [
      { type: 'rect', x: 0, y: 0, width: 1080, height: 1080, fill: '#F9FAFB' },
      { type: 'rect', x: 80, y: 360, width: 10, height: 180, fill: '#3B82F6' },
      { type: 'text', x: 130, y: 340, text: '"Your inspiring quote goes here. Make it powerful and memorable."', fontSize: 52, fontFamily: 'Georgia', fill: '#111827', fontStyle: 'italic', width: 870, align: 'left' },
      { type: 'text', x: 130, y: 620, text: '— Author Name', fontSize: 36, fontFamily: 'Arial', fill: '#6B7280', width: 870, align: 'left' },
    ],
  },
  {
    id: 'stats',
    name: 'Stats',
    category: 'Content',
    preview: { bg: '#ECFDF5', accent: '#10B981' },
    elements: [
      { type: 'rect', x: 0, y: 0, width: 1080, height: 1080, fill: '#ECFDF5' },
      { type: 'text', x: 80, y: 260, text: '100%', fontSize: 220, fontFamily: 'Arial', fill: '#10B981', fontStyle: 'bold', width: 920, align: 'center' },
      { type: 'text', x: 80, y: 530, text: 'Your Key Metric', fontSize: 60, fontFamily: 'Arial', fill: '#065F46', fontStyle: 'bold', width: 920, align: 'center' },
      { type: 'text', x: 80, y: 630, text: 'Add context for this number', fontSize: 36, fontFamily: 'Arial', fill: '#6B7280', width: 920, align: 'center' },
    ],
  },
  {
    id: 'cta',
    name: 'Call to Action',
    category: 'Marketing',
    preview: { bg: '#7C3AED', accent: '#FFFFFF' },
    elements: [
      { type: 'rect', x: 0, y: 0, width: 1080, height: 1080, fill: '#7C3AED' },
      { type: 'text', x: 80, y: 320, text: 'Ready to Get Started?', fontSize: 80, fontFamily: 'Arial', fill: '#FFFFFF', fontStyle: 'bold', width: 920, align: 'center' },
      { type: 'text', x: 80, y: 450, text: 'Join thousands of users who are already using our platform.', fontSize: 40, fontFamily: 'Arial', fill: '#DDD6FE', width: 920, align: 'center' },
      { type: 'rect', x: 240, y: 620, width: 600, height: 110, fill: '#FFFFFF', cornerRadius: 55 },
      { type: 'text', x: 240, y: 643, text: 'Start Free Today →', fontSize: 48, fontFamily: 'Arial', fill: '#7C3AED', fontStyle: 'bold', width: 600, align: 'center' },
    ],
  },
  {
    id: 'split',
    name: 'Split Layout',
    category: 'Content',
    preview: { bg: '#EFF6FF', accent: '#1E40AF' },
    elements: [
      { type: 'rect', x: 0, y: 0, width: 1080, height: 1080, fill: '#FFFFFF' },
      { type: 'rect', x: 0, y: 0, width: 460, height: 1080, fill: '#EFF6FF' },
      { type: 'text', x: 40, y: 340, text: 'Key Point', fontSize: 72, fontFamily: 'Arial', fill: '#1E40AF', fontStyle: 'bold', width: 380, align: 'center' },
      { type: 'text', x: 40, y: 450, text: 'Supporting detail here', fontSize: 38, fontFamily: 'Arial', fill: '#3B82F6', width: 380, align: 'center' },
      { type: 'text', x: 520, y: 220, text: 'Your Main Heading', fontSize: 64, fontFamily: 'Arial', fill: '#111827', fontStyle: 'bold', width: 500, align: 'left' },
      { type: 'rect', x: 520, y: 320, width: 80, height: 6, fill: '#3B82F6' },
      { type: 'text', x: 520, y: 360, text: 'Add your detailed description here. Expand on your key point with supporting information and context.', fontSize: 36, fontFamily: 'Arial', fill: '#374151', width: 500, align: 'left' },
    ],
  },
];

export const TEMPLATE_CATEGORIES = [...new Set(EDITOR_TEMPLATES.map(t => t.category))];
